import BaseColumnsStrategy from '../BaseColumnsStrategy'

export default function CSVColumnsStrategy() {}

CSVColumnsStrategy.prototype = _.create(BaseColumnsStrategy.prototype);

CSVColumnsStrategy.prototype.init = function()
{
    BaseColumnsStrategy.prototype.init.call( this );
    return this;
};

CSVColumnsStrategy.prototype.createTimeValueCell = function ( className )
{
    return ReportPreviewUtils.createCell( this.makeTimeValue(), className );
};

CSVColumnsStrategy.prototype.makeTimeValue = function()
{
    return ReportPreviewUtils.getCSVTimeValue();
};

CSVColumnsStrategy.prototype.addTimeValueCell = function ( row, className )
{
    let resultClass = className ? "value " + className : "value"
    BaseColumnsStrategy.prototype.addTimeValueCell.call( this, row, resultClass );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/CSVColumnsStrategy.js